import React from "react";
import "antd/dist/antd.css";
import Top from "../../components/common/Top";
import { Layout, Input, Button, Form, message } from "antd";
import actionWays from "../../redux/actions";
import { trialApply } from "../../utils/api";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { msgSuccess, msgError } from "../../utils/msg";
import { withTranslation } from "react-i18next";
import { adaptation } from "../../utils/adaptation";
import "./index.scss";
import { setInterval, setTimeout } from "core-js";
const { Content } = Layout;
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clickShow: false,
    };
  }

  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    adaptation()
  }

  onFinish = async (value) => {
    if (this.state.clickShow) {
      return msgError("请勿重复操作");
    } else {
      this.setState({
        clickShow: true,
      });
    }
    let data = await trialApply(value);
    if (data?.code == 0) {
      msgSuccess("操作成功");
    } else {
      msgError(data?.message);
    }
    let clickNum = 0;
    const interNum = setInterval(() => {
      clickNum++;
      if (clickNum > 4) {
        this.state = {
          clickShow: false,
        };
        clearInterval(interNum);
      }
    }, 1000);
  };
  checkDomain = (rule, value, callback) => {
    const { t } = this.props;
    // 开头必须是数字1，第二位可以是3、4、5、6、7、8、9中的任意一个数字，表示接下来必须是9个数字总计11位数字
    const msgs = /^1[3456789]\d{9}$/;
    if (!msgs.test(value)) {
      callback(t("onlineExperience.con4Reminder1"));
    } else {
      callback();
    }
  };
  render() {
    const { t } = this.props;
    return (
      <Layout>
        <Top />
        <Content id="contentId">
          <div className="apply_form">
            <div className="apply_form_left">
              <img
                src={require("../../assets/images/apply/apply1.png").default}
              />
            </div>
            <div className="apply_form_right">
              <div className="apply_form_right_til">{t("onlineExperience.title")}</div>
              <Form
                layout="vertical"
                size={"large"}
                onFinish={(e) => this.onFinish(e)}
              >
                <Form.Item
                  label={t("onlineExperience.con1")}
                  name="companyName"
                  rules={[{ required: true, message: t("onlineExperience.con1Reminder")}]}
                >
                  <Input />
                </Form.Item>
                <Form.Item label={t("onlineExperience.con2")} name="industryType">
                  <Input />
                </Form.Item>
                <Form.Item
                  label={t("onlineExperience.con3")}
                  name="applyname"
                  rules={[{ required: true, message: t("onlineExperience.con3Reminder") }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label={t("onlineExperience.con4")}
                  name="tel"
                  rules={[
                    { required: true, message: t("onlineExperience.con4Reminder") },
                    { validator: this.checkDomain },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item label={t("onlineExperience.con5")} name="city">
                  <Input />
                </Form.Item>
                <div className="submit_but">
                  <Button type="primary" htmlType="submit">
                    {t("onlineExperience.sub")}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(Login)));
